import type { SubmitConsentsBody } from '@/lib/api/consents/types';

const joinTypes = (types: string[]) => types.slice().sort().join(',');

export const summarizeConsentDecisions = (body: SubmitConsentsBody) => {
  const accepted = body.decisions
    .filter((decision) => decision.response === 'YES')
    .map((decision) => decision.consentType);
  const declined = body.decisions
    .filter((decision) => decision.response === 'NO')
    .map((decision) => decision.consentType);

  return {
    accepted_types: joinTypes(accepted),
    declined_types: joinTypes(declined),
    accepted_count: accepted.length,
    declined_count: declined.length,
  };
};
